import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // ===== عام =====
            retry: 'إعادة المحاولة',
      appName: 'تطبيق سيدات',
      subtitle: 'مساحتك الخاصة والأكثر أماناً',
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      phone: 'رقم الجوال',
      name: 'الاسم الكامل',
      logout: 'تسجيل الخروج',
      welcome: 'مرحباً',
      balance: 'الرصيد',
      riyal: 'ريال',
      captain: 'سائقة',
      passenger: 'راكبة',
      gender: 'الجنس',
      female: 'أنثى',
      male: 'ذكر',
      language: 'اللغة',
      arabic: 'العربية',
      english: 'English',
      noAccount: 'ليس لديك حساب؟',
      signUp: 'سجل الآن',
      haveAccount: 'لديك حساب؟',
      changeTheme: 'تغيير الثيم',
      home: 'الرئيسية',
           // ===== الأداء وتقرير الكابتن =====
            totalRequests: 'إجمالي الطلبات',
            acceptedRequests: 'الطلبات المقبولة',
            rejectedRequests: 'الطلبات المرفوضة',
            avgResponseTime: 'متوسط وقت الاستجابة',
            periodStats: 'إحصائيات الفترات',
            today: 'اليوم',
            thisWeek: 'هذا الأسبوع',
            thisMonth: 'هذا الشهر',
            captainLeaderboard: 'ترتيب السائقات',
            rank: '# التصنيف',
            acceptanceRate: 'نسبة القبول',
            responseTime: 'سرعة الاستجابة',
            noDataFound: 'لا توجد بيانات',
            leaderboard: 'لوحة المتصدرين',
            performance: 'تقرير الأداء',
            viewReport: 'عرض تقرير الأداء',
      
      // ===== صفحة التسجيل =====
      createAccount: 'إنشاء حساب جديد',
      joinMessage: 'انضم إلى خدمة النقل الآمنة للنساء',
      fullName: 'الاسم الكامل',
      role: 'الدور',
      carInfo: 'معلومات السيارة',
      carModel: 'موديل السيارة',
      carPlate: 'رقم اللوحة',
      carColor: 'لون السيارة',
      carImage: 'صورة السيارة',
      uploadCarImage: 'رفع صورة السيارة',
      identityDocuments: 'وثائق الهوية',
      idImage: 'صورة الهوية الوطنية / الإقامة',
      uploadIdImage: 'رفع صورة الهوية',
      licenseImage: 'صورة رخصة القيادة',
      uploadLicenseImage: 'رفع صورة الرخصة',
      documentsNote: 'سيتم مراجعة المستندات من قبل الإدارة للموافقة على طلبك',
      registerSuccess: 'تم إنشاء الحساب بنجاح',
      registerError: 'حدث خطأ في إنشاء الحساب',
      
      // ===== طلب رحلة =====
      requestRide: 'طلب رحلة',
      rideDetails: 'تفاصيل الرحلة',
      pickupLocation: 'نقطة الانطلاق',
      dropoffLocation: 'الوجهة',
      enterPickup: 'أدخل عنوان الانطلاق',
      enterDropoff: 'أدخل عنوان الوجهة',
      savedAddresses: 'العناوين المفضلة',
      searchAddress: 'ابحث عن عنوان...',
      enterShortName: 'أدخل اسم مختصر للعنوان (مثل: المنزل، العمل)',
      saveCurrentAddress: 'حفظ العنوان الحالي',
      selectAddressFirst: 'يرجى اختيار عنوان أولاً',
      calculateFare: 'حساب السعر التقديري',
      estimatedFare: 'السعر التقديري',
      distance: 'المسافة',
      duration: 'المدة',
      minutes: 'دقيقة',
      vehicleType: 'نوع المركبة',
      standard: 'قياسي',
      luxury: 'فاخر',
      van: 'فان',
      bike: 'دراجة',
      
      // ===== لوحة الكابتن =====
      captainDashboard: 'لوحة الكابتن',
      totalRides: 'إجمالي الرحلات',
      completedRides: 'الرحلات المكتملة',
      totalEarnings: 'إجمالي الأرباح',
      rating: 'التقييم',
      todayEarnings: 'أرباح اليوم',
      monthEarnings: 'أرباح الشهر',
      online: 'متصل',
      offline: 'غير متصل',
      readyToReceiveRides: 'أنت متاحة لاستقبال الطلبات',
      notReceivingRides: 'أنت غير متاحة لاستقبال الطلبات',
      goOnline: 'متابعة الآن',
      goOffline: 'إلغاء التوفر',
      approved: 'معتمد',
      pending: 'قيد المراجعة',
      rides: 'رحلة',
      documentsStatus: 'حالة المستندات',
      uploaded: 'مرفوع',
      notUploaded: 'غير مرفوع',
      performanceReport: 'تقرير الأداء',
      totalHours: 'ساعات العمل',
      viewReport: 'عرض تقرير الأداء',
      active: 'النشطة',
      completed: 'المكتملة',
      cancelled: 'الملغية',
      noRidesFound: 'لا توجد رحلات',
      availableRides: 'رحلات متاحة',
      accept: 'قبول',
      reject: 'رفض',
      start: 'بدء',
      complete: 'إنهاء',
      cancel: 'إلغاء',
      errorLoadingData: 'حدث خطأ في تحميل البيانات',
            carPlateArabic: 'رقم اللوحة (عربي)',
            carPlateEnglish: 'رقم اللوحة (إنجليزي)',

      // ===== تحديث بيانات الكابتن =====
      settings: 'الإعدادات',
      updateSuccess: 'تم تحديث البيانات بنجاح',
      updateError: 'حدث خطأ في تحديث البيانات',
      saving: 'جاري الحفظ...',
      save: 'حفظ',
      upload: 'رفع',
      licenseNumber: 'رقم الرخصة',

      // ===== حالات الرحلة =====
      status: 'الحالة',
      pending: 'قيد الانتظار',
      accepted: 'مقبولة',
      started: 'قيد التنفيذ',
      completed: 'مكتملة',
      cancelled: 'ملغية',
      noRides: 'لا توجد رحلات',
      errorLoadingRides: 'حدث خطأ في تحميل الرحلات',
      myRides: 'رحلاتي',
    }
  },
  en: {
    translation: {
      // ===== General =====
      retry: 'Retry',
      appName: 'Saydat Platform',
      subtitle: 'Your Own Private & Safest Space',
      login: 'Sign In',
      register: 'Sign Up',
      email: 'Email',
      password: 'Password',
      phone: 'Phone Number',
      name: 'Full Name',
      logout: 'Logout',
      welcome: 'Welcome',
      balance: 'Balance',
      riyal: 'SAR',
      captain: 'Captain',
      passenger: 'Passenger',
      gender: 'Gender',
      female: 'Female',
      male: 'Male',
      language: 'Language',
      arabic: 'Arabic',
      english: 'English',
      noAccount: "Don't have an account?",
      signUp: 'Sign up now',
      haveAccount: 'Already have an account?',
      changeTheme: 'Change Theme',
      home: 'Home',
      
      // ===== Register Page =====
      createAccount: 'Create Account',
      joinMessage: 'Join the safe transportation service for women',
      fullName: 'Full Name',
      role: 'Role',
      carInfo: 'Car Information',
      carModel: 'Car Model',
      carPlate: 'Plate Number',
      carColor: 'Car Color',
      carImage: 'Car Image',
      uploadCarImage: 'Upload Car Image',
      identityDocuments: 'Identity Documents',
      idImage: 'National ID / Residency Image',
      uploadIdImage: 'Upload ID Image',
      licenseImage: 'Driver License Image',
      uploadLicenseImage: 'Upload License Image',
      documentsNote: 'Documents will be reviewed by the administration for approval',
      registerSuccess: 'Account created successfully',
      registerError: 'Error creating account',
      
      // ===== Request Ride =====
      requestRide: 'Request a Ride',
      rideDetails: 'Ride Details',
      pickupLocation: 'Pickup Location',
      dropoffLocation: 'Dropoff Location',
      enterPickup: 'Enter pickup address',
      enterDropoff: 'Enter dropoff address',
      savedAddresses: 'Saved Addresses',
      searchAddress: 'Search for an address...',
      enterShortName: 'Enter a short name for the address (e.g., Home, Work)',
      saveCurrentAddress: 'Save Current Address',
      selectAddressFirst: 'Please select an address first',
      calculateFare: 'Calculate Estimated Fare',
      estimatedFare: 'Estimated Fare',
      distance: 'Distance',
      duration: 'Duration',
      minutes: 'min',
      vehicleType: 'Vehicle Type',
      standard: 'Standard',
      luxury: 'Luxury',
      van: 'Van',
      bike: 'Bike',
      
      // ===== Captain data update =====
      settings: 'Settings',
      updateSuccess: 'Data updated successfully',
      updateError: 'Error updating data',
      saving: 'Saving...',
      save: 'Save',
      upload: 'Upload',
      licenseNumber: 'License Number', 
      carPlateArabic: 'Plate Number (Arabic)',
      carPlateEnglish: 'Plate Number (English)',

      // ===== Captain Dashboard =====
      captainDashboard: 'Captain Dashboard',
      totalRides: 'Total Rides',
      completedRides: 'Completed Rides',
      totalEarnings: 'Total Earnings',
      rating: 'Rating',
      todayEarnings: "Today's Earnings",
      monthEarnings: "Month's Earnings",
      online: 'Online',
      offline: 'Offline',
      readyToReceiveRides: 'Ready to receive rides',
      notReceivingRides: 'Not receiving rides',
      goOnline: 'Go Online',
      goOffline: 'Go Offline',
      approved: 'Approved',
      pending: 'Pending Review',
      rides: 'Rides',
      documentsStatus: 'Documents Status',
      uploaded: 'Uploaded',
      notUploaded: 'Not Uploaded',
      performanceReport: 'Performance Report',
      totalHours: 'Total Hours',
      viewReport: 'View Performance Report',
      active: 'Active',
      completed: 'Completed',
      cancelled: 'Cancelled',
      noRidesFound: 'No rides found',
      availableRides: 'Available Rides',
      accept: 'Accept',
      reject: 'Reject',
      start: 'Start',
      complete: 'Complete',
      cancel: 'Cancel',
      errorLoadingData: 'Error loading data',
      // ===== Performance and Captain's Report =====
            totalRequests: 'Total Requests',
            acceptedRequests: 'Accepted Requests',
            rejectedRequests: 'Rejected Requests',
            avgResponseTime: 'Avg Response Time',
            periodStats: 'Period Statistics',
            today: 'Today',
            thisWeek: 'This Week',
            thisMonth: 'This Month',
            captainLeaderboard: 'Captain Leaderboard',
            rank: 'Rank',
            acceptanceRate: 'Acceptance Rate',
            responseTime: 'Response Time',
            noDataFound: 'No data found',
            leaderboard: 'Leaderboard',
            performance: 'Performance Report',
            viewReport: 'View Performance Report',
      // ===== Ride Status =====
      status: 'Status',
      pending: 'Pending',
      accepted: 'Accepted',
      started: 'Started',
      completed: 'Completed',
      cancelled: 'Cancelled',
      noRides: 'No rides found',
      errorLoadingRides: 'Error loading rides',
      myRides: 'My Rides',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar',
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;